import React, { lazy, Suspense } from 'react'
import { Provider } from 'jotai'
import { Route, Router } from 'react-router-dom'
import { PageContentSlot } from '@wf-mfe/layout'
import { history } from '@wf-mfe/navigation'
import { useIsTreatmentEnabled } from '@wf-mfe/toggles'
const NotificationCenter = lazy(() => import('./notification-center'))
const ShimmedAnnouncements = lazy(() => import('./shims/announcements'))
const ShimmedNotifications = lazy(() => import('./shims/notifications'))

export default function NotificationCenterRouter() {
  const isUnshimmed = useIsTreatmentEnabled('unshim-announcements-notifications')

  return (
    <Provider>
      <Router history={history}>
        <PageContentSlot mfeName="@wf-mfe/notification-hub">
          <Suspense fallback="">
            <Route path="/notifications">
              {isUnshimmed ? <NotificationCenter /> : <ShimmedNotifications />}
            </Route>
            <Route path="/announcements/:subPath?">
              <ShimmedAnnouncements />
            </Route>
          </Suspense>
        </PageContentSlot>
      </Router>
    </Provider>
  )
}
